import {BaseAction} from '../../common/BaseAction'
import {PushActionsTypes} from './types'
import {PushState} from '../types/PushState'

const initialPushState: PushState = {
  messages: undefined,
}

export default function push(state: PushState = initialPushState, dispatch: BaseAction): PushState {
  switch (dispatch.type) {
    case PushActionsTypes.SET_PUSH_MESSAGES: {
      return {
        ...state,
        messages: dispatch.payload,
      }
    }

    case PushActionsTypes.READ_PUSH_MESSAGE_SUCCESS: {
      let messages = state.messages ?? []
      const messageIndex = messages.findIndex((m) => m.pushQueueId === dispatch.payload.pushQueueId)
      if (messageIndex !== -1) {
        messages[messageIndex] = {
          ...messages[messageIndex],
          readDate: new Date(),
        }
      }
      return {
        ...state,
        messages: messages ? [...messages] : [],
      }
    }

    case PushActionsTypes.HIDE_PUSH_MESSAGE_SUCCESS: {
      let messages = state.messages ?? []
      const messageIndex = messages.findIndex((m) => m.pushQueueId === dispatch.payload.pushQueueId)
      if (messageIndex !== -1) {
        messages[messageIndex] = {
          ...messages[messageIndex],
          isHidden: true,
        }
      }
      return {
        ...state,
        messages: messages ? [...messages] : [],
      }
    }

    default:
      return state
  }
}
